import { isClerkAPIResponseError } from "@clerk/clerk-react/errors";

const FALLBACK_MESSAGE = "Something went wrong. Please try again.";

export function clerkErrorMessage(error: unknown, fallback = FALLBACK_MESSAGE) {
  if (!isClerkAPIResponseError(error)) return fallback;

  const [firstError] = error.errors;
  return firstError?.longMessage ?? firstError?.message ?? fallback;
}
